import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument  } from '@angular/fire/firestore';
import { Observable, of } from 'rxjs';
import { switchMap} from 'rxjs/operators';
import { auth } from 'firebase/app';
import { AuthService } from '../auth.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class LoginComponent implements OnInit {

  redirectDelay: number = 0;
  showMessages: any = {};
  showLogin: boolean = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  rememberMe:boolean =true;

constructor(public auth: AuthService, private router: Router,
  private toast: NbToastrService ) {

  //Implementación de FormGroup para login

    // this.todo = this.formBuilder.group({
    //   nombre: ['', Validators.required],
    //   correo: ['',Validators.required],
    //   fnacimiento: ['',Validators.required],
    //   telefono: ['',Validators.required],
    //   direccion: ['',Validators.required],
    // });

  }
  ngOnInit() {
    if (this.auth.authenticated) {
      this.router.navigate(['/home']);
    }

   }
   loginWithGoogle() {

   }
   async loggin() {
     this.errors = [];
     this.messages = [];
     this.submitted = true;
     const resp = await this.auth.emailSignin(this.user)

     if(resp==="error"){
       this.toast.danger('Error log in user','Error');
     }
     else if (resp==="noemailverified") {
       this.toast.danger('You have to verify your email to log in','Error');
     }
     else if (resp==="authenticated"){
       this.toast.success('Login succesful','Success');
     }
     else {
       this.toast.danger('Error log in user','Error');
     }

   }
}
